import { fmtBrl } from '../shared/formatters'
import { summarizeRaw } from '../shared/periods'

export const buildGrossProfitRow = ({
  monthKeys,
  hybridAgg,
  summaryPeriods,
}) => {
  const rawValues = monthKeys.map((_, i) => {
    const retailRevenue = hybridAgg[i]?._grossRevenue;
    if (retailRevenue == null) return null;

    const unitsSold = hybridAgg[i]?._unitsSold;
    const unitCost = hybridAgg[i]?._unitCost;

    if (unitsSold != null && unitCost != null) {
      return retailRevenue - unitsSold * unitCost;
    }

    const grossMargin = hybridAgg[i]?._grossMargin;
    return grossMargin != null ? retailRevenue * grossMargin : null;
  });

  const values = rawValues.map(v => v != null ? fmtBrl(v) : null);

  const semRawValues = summarizeRaw(rawValues, summaryPeriods);

  return {
    values,
    rawValues,
    semValues: semRawValues.map(v => v != null ? fmtBrl(v) : null),
    semRawValues,
  };
};